import api from "./api";

export default {
  install(Vue, options) {
    Vue.prototype.$http = api;
  },
};
